import api from '@/api/Api'
import ApiModel from '@/model/ApiModel'
let { Const } = ApiModel;


const state = {
    materialId: null,
    material: {},
    loading: false,
    show: false
}

// getters
const getters = {
}

// actions
const actions = {
    async hide({ commit, state }) {
        commit("show", false);
    },
    async show({ commit, state }, id) {
        if (id == state.materialId) {
            commit("show", true);
            return;
        }

        commit("setId", id);
        commit("show", true);
        commit("loading", true);
        try {

            let ret = await api.call("material/info", { materialId: id });
            commit("setMaterial", ret.data);

        } catch (e) {
            //
        }

        commit("loading", false);
    }
}

// mutations
const mutations = {
    setId(state, val) {
        state.materialId = val;
    },
    setMaterial(state, val) {
        state.material = val;
    },
    show(state, val) {
        state.show = val;
    },
    loading(state, val) {
        state.loading = val;
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}